import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";

const typeLabel: Record<ContentItem["type"], string> = {
  plot: "剧情",
  cast: "演员",
  review: "剧评",
  news: "动态",
};

export default function RelatedList({ items }: { items: ContentItem[] }) {
  if (items.length === 0) {
    return (
      <p className="rounded-md bg-background-100 px-3 py-4 text-center text-xs text-foreground-500">
        暂无相关内容
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const title = item.type === "cast" ? `${item.actor} 饰 ${item.roleName}` : item.title;
        const cover = item.type === "cast" ? item.avatar : item.cover;
        return (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 rounded-md border border-background-200 p-2.5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
          >
            <div className="h-14 w-14 shrink-0 overflow-hidden rounded-md">
              <img
                src={cover}
                alt={title}
                title={`${title} - 相关内容`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <span className="text-[11px] text-primary-600">{typeLabel[item.type]}</span>
              <h4 className="line-clamp-2 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                {title}
              </h4>
            </div>
          </Link>
        );
      })}
    </div>
  );
}